import { useImageCropContext } from "../../providers/ImageCropProvider";
import {
  ArrowUturnLeftIcon,
  ArrowUturnRightIcon,
  MinusIcon,
  PlusIcon,
} from "@heroicons/react/24/solid";
import classNames from "classnames";
import { StandardButton } from "@/components/common/StandardButton";

export const ZoomSlider = ({ className }) => {
  const {
    zoom,
    setZoom,
    handleZoomIn,
    handleZoomOut,
    max_zoom,
    min_zoom,
    zoom_step,
  } = useImageCropContext();

  return (
    <div
      className={classNames(
        className,
        "flex items-center justify-center gap-2",
      )}
    >
      <StandardButton
        variant="icon"
        size="sm"
        onClick={handleZoomOut}
        className="!p-1"
        aria-label="Zoom out"
      >
        <MinusIcon className="text-gray-400 w-4" aria-hidden="true" />
      </StandardButton>
      <input
        type="range"
        name="zoom"
        min={min_zoom}
        max={max_zoom}
        step={zoom_step}
        value={zoom}
        onChange={(e) => {
          setZoom(Number(e.target.value));
        }}
        aria-label="Zoom level"
      />
      <StandardButton
        variant="icon"
        size="sm"
        onClick={handleZoomIn}
        className="!p-1"
        aria-label="Zoom in"
      >
        <PlusIcon className="text-gray-400 w-4" aria-hidden="true" />
      </StandardButton>
    </div>
  );
};

export const RotationSlider = ({ className }) => {
  const {
    rotation,
    setRotation,
    max_rotation,
    min_rotation,
    rotation_step,
    handleRotateAntiCw,
    handleRotateCw,
  } = useImageCropContext();

  return (
    <div
      className={classNames(
        className,
        "flex items-center justify-center gap-2",
      )}
    >
      <StandardButton
        variant="icon"
        size="sm"
        onClick={handleRotateAntiCw}
        className="!p-1"
        aria-label="Rotate left"
      >
        <ArrowUturnLeftIcon className="text-gray-400 w-4" aria-hidden="true" />
      </StandardButton>
      <input
        type="range"
        name="rotation"
        min={min_rotation}
        max={max_rotation}
        step={rotation_step}
        value={rotation}
        onChange={(e) => {
          setRotation(Number(e.target.value));
        }}
        aria-label="Rotation angle"
      />
      <StandardButton
        variant="icon"
        size="sm"
        onClick={handleRotateCw}
        className="!p-1"
        aria-label="Rotate right"
      >
        <ArrowUturnRightIcon className="text-gray-400 w-4" aria-hidden="true" />
      </StandardButton>
    </div>
  );
};
